import { Component, OnInit } from '@angular/core';
import { UnsupportedBrowserService } from './unsupported-browser.service';
import { BrowserDetectionService } from '../shared/browser/browser-detection.service';

@Component({
  selector: 'ls-unsupported-browser',
  templateUrl: './unsupported-browser.component.html',
  styleUrls: ['./unsupported-browser.component.scss']
})
export class UnsupportedBrowserComponent implements OnInit {
  public showUnsupportedBrowserWarning = false;

  constructor(
    private unsupportedBrowserService: UnsupportedBrowserService,
    private browserDetectionService: BrowserDetectionService
  ) {}

  public ngOnInit(): void {
    const supportedBrowser: boolean = this.unsupportedBrowserService.isSupportedBrowser(
      this.browserDetectionService.isChrome(),
      this.browserDetectionService.isSafari()
    );

    this.showUnsupportedBrowserWarning = this.unsupportedBrowserService.showUnsupportedBrowserWarning(
      supportedBrowser,
      this.unsupportedBrowserService.isDismissed()
    );
  }

  public dismiss(): void {
    this.unsupportedBrowserService.dismiss();
    this.showUnsupportedBrowserWarning = false;
  }
}
